import {Component, inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {ApiNotificationResponseDto} from '@birco/rainmesh-api';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {IconsPipe} from '../../../../shared/pipes/icons.pipe';
import {TagComponent} from '../../../../shared/components/tag/tag.component';
import {RelativeDatePipe} from '../../../../shared/pipes/relative-date.pipe';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {getNotificationContent} from '../../utils/notification-utils';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {NotificationActions} from '../../state/notification.actions';
import {LabelConverter} from '../../../../shared/converter/label.converter';

interface NotificationToastData {
  notification: ApiNotificationResponseDto;
}

@Component({
  selector: 'app-notification-toast',
  imports: [
    IconComponent,
    IconsPipe,
    TagComponent,
    RelativeDatePipe,
    TranslatePipe,
  ],
  templateUrl: './notification-toast.component.html',
  styleUrl: './notification-toast.component.scss'
})
export class NotificationToastComponent {
  private router = inject(Router);
  private store = inject(Store);
  private translateService = inject(TranslateService);
  private snackBarRef = inject(MatSnackBarRef<NotificationToastComponent>);

  readonly data = inject<NotificationToastData>(MAT_SNACK_BAR_DATA);

  get notificationContent() {
    return getNotificationContent(this.data.notification, this.translateService);
  }

  get hasLink() {
    return !!this.notificationContent.routerLink;
  }

  async openNotification() {
    if (!this.hasLink) {
      return;
    }

    if (!this.data.notification.readAt && this.data.notification.id) {
      this.store.dispatch(NotificationActions.public.markAsRead({id: this.data.notification.id}));
    }

    this.snackBarRef.dismiss();
    await this.router.navigate(this.notificationContent.routerLink!);
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }

  protected readonly LabelConverter = LabelConverter;
}
